document.addEventListener("DOMContentLoaded", function () {
  const cart1 = document.querySelector(".itg_cart_1");
  const cart2 = document.querySelector(".itg_cart_2");

  if (!cart1 || !cart2) return;

  function resetSticky(section) {
    section.style.position = "";
    section.style.top = "";
    section.style.zIndex = "";
  }

  function makeSticky(section, zIndex) {
    section.style.position = "sticky";
    section.style.top = "0px";
    section.style.zIndex = zIndex.toString();
  }

  function handleScroll() {
    const scrollY = window.scrollY;
    const cart2Top = cart2.offsetTop;

    // If we have scrolled past cart2's top, disable all sticky
    if (scrollY >= cart2Top) {
      resetSticky(cart1);
      resetSticky(cart2);
    } else {
      // Make cart1 sticky
      makeSticky(cart1, 1);

      // Make cart2 sticky only if it's not at the top yet
      const cart2Rect = cart2.getBoundingClientRect();
      if (cart2Rect.top > 0) {
        makeSticky(cart2, 2);
      } else {
        resetSticky(cart2);
      }
    }
  }

  // Debounced scroll for performance
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const target = document.querySelector(targetId);

      if (target) {
        const headerOffset = 100;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});


  // read more button //



//   document.addEventListener("DOMContentLoaded", function () {
//   const containers = document.querySelectorAll(".itg_content-toggle-container");

//   if (containers.length > 0) {
//     containers.forEach((container) => {
//       const btn = container.querySelector(".itg_toggle-content-btn");
//       const shortContent_extra = container.closest(".product-description")?.querySelector(".desc_contain");
//       const fullContent = container.querySelector(".full-content");

//       if (!btn || !shortContent_extra || !fullContent) {
//         console.warn("Missing required elements in container:", container);
//         return;
//       }

//       btn.addEventListener("click", () => {
//         const isExpanded = container.classList.contains("expanded");

//         if (isExpanded) {
//           // Collapse
//           fullContent.style.maxHeight = fullContent.scrollHeight + "px";
//           void fullContent.offsetHeight;
//           fullContent.style.maxHeight = "0";
//           btn.textContent = "Read more";
//           container.classList.remove("expanded");

//           setTimeout(() => {
//             shortContent_extra.style.webkitMaskImage =
//               "linear-gradient(to right, black 80%, transparent 100%)";
//             shortContent_extra.style.maskImage =
//               "linear-gradient(to right, black 70%, transparent 100%)";
//           }, 600);
//         } else {
//           // Expand
//           shortContent_extra.style.webkitMaskImage = "none";
//           shortContent_extra.style.maskImage = "none";

//           container.classList.add("expanded", "expanding");
//           fullContent.style.maxHeight = fullContent.scrollHeight + "px";
//           btn.textContent = "Read less";

//           setTimeout(() => {
//             container.classList.remove("expanding");
//             fullContent.style.maxHeight = "none";
//           }, 600);
//         }
//       });
//     });
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".itg_content-toggle-container");

  if (containers.length > 0) {
    containers.forEach((container) => {
      const btn = container.querySelector(".itg_toggle-content-btn");
      const shortContent_extra = container.closest(".product-description")?.querySelector(".desc_contain");
      const fullContent = container.querySelector(".full-content");

      if (!btn || !shortContent_extra || !fullContent) {
        console.warn("Missing required elements in container:", container);
        return;
      }

     btn.addEventListener("click", (e) => {
  e.stopPropagation();

        const isExpanded = container.classList.contains("expanded");
        let product_short_description = document.querySelector('.product_short_description');

        if (isExpanded) {
          // ---- Collapse ----
          product_short_description.classList.remove("hidden"); // show instantly

          fullContent.style.maxHeight = fullContent.scrollHeight + "px";
          void fullContent.offsetHeight; // force reflow
          fullContent.style.maxHeight = "0";
          btn.textContent = "Read more";
          container.classList.remove("expanded");

          // Mask fade effect
          setTimeout(() => {
            shortContent_extra.style.webkitMaskImage =
              "linear-gradient(to right, black 80%, transparent 100%)";
            shortContent_extra.style.maskImage =
              "linear-gradient(to right, black 70%, transparent 100%)";
          }, 300);

        } else {
          // ---- Expand ----
          product_short_description.classList.add("hidden"); // hide instantly

          shortContent_extra.style.webkitMaskImage = "none";
          shortContent_extra.style.maskImage = "none";

          container.classList.add("expanded", "expanding");
          fullContent.style.maxHeight = fullContent.scrollHeight + "px";
          btn.textContent = "Read less";

          setTimeout(() => {
            container.classList.remove("expanding");
            fullContent.style.maxHeight = "none";
          }, 600);
        }
      });
    });
  }
});

    


